export enum CatalogPageTypes {
  digitalBridge = 'digital bridge',
  courses = 'courses page',
  iframePage = 'iframe page',
  coursePage = 'course page',
  registerPage = 'register page',
  activatePage = 'activate page',
  activateByVerifiedPhonePage = 'activate by verified phone page',
}
